/**
 * FlagStripe — the red/white/blue ribbon used on the app header, footer and
 * tab bars, with a PACE-style ripple: a soft light band sweeps across the
 * stripe on every route change (and on first mount), reading as "the app is
 * fetching your page". Pure CSS animation, replayed by remounting the glint
 * via a key on the pathname.
 */
import React from "react";
import { useLocation } from "react-router-dom";

interface Props {
  height?: number;
  style?: React.CSSProperties;
  className?: string;
}

export default function FlagStripe({ height = 4, style, className }: Props) {
  const { pathname } = useLocation();
  return (
    <div
      aria-hidden
      className={className}
      style={{
        position: "relative",
        overflow: "hidden",
        height,
        background: "linear-gradient(90deg, var(--civic-red) 0%, var(--civic-cream) 50%, var(--civic-navy) 100%)",
        ...style,
      }}
    >
      <style>{`
        @keyframes flagStripeRipple {
          0%   { transform: translateX(-140%); opacity: 0; }
          12%  { opacity: 1; }
          88%  { opacity: 1; }
          100% { transform: translateX(340%); opacity: 0; }
        }
      `}</style>
      {/* Remounts (and thus replays) whenever the route changes. */}
      <span
        key={pathname}
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          width: "30%",
          background:
            "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.9) 45%, rgba(255,255,255,0.9) 55%, transparent 100%)",
          mixBlendMode: "screen",
          animation: "flagStripeRipple 1.15s cubic-bezier(0.4, 0, 0.2, 1) 1",
          animationFillMode: "forwards",
          pointerEvents: "none",
        }}
      />
    </div>
  );
}
